import { Card, CardHeader, Avatar, Box, Chip, Typography, Button } from "@mui/material";
import React, { useState } from "react";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import HomeIcon from "@mui/icons-material/Home";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import BusinessIcon from "@mui/icons-material/Business";
import { useTheme } from "@mui/material/styles";
import { AddressFormModal } from "../forms";
import { phoneNumberFormat } from "src/common/UtilFunctions";
import ApiResources from "src/providers/ApiResources";
import { StateEnum } from "src/common/enum";

export const AddressCard = (props) => {
  const { record, type = "shipping", ...rest } = props;
  const [showAddressEdit, setShowAddressEdit] = useState(false);
  let address = type === "shipping" ? record.shipping_address : record.billing_address;

  const theme = useTheme();

  const cardStyle = {
    padding: "10px",
    border: "1px solid #ebebeb",
    borderRadius: "8px"
  };

  const sectionStyle = {
    margin: "5px 0 5px 15px",
    alignItems: "center",
    display: "flex",
  };

  const iconStyle = {
    marginRight: "10px",
    color: theme.palette.grey["700"],
    fontSize: "16px",
  };

  const textStyle = { fontSize: "14px" };
  
  const getState = (address) => {
    if (!address.state) {
      return '';
    }

    let stateEnum = StateEnum.find((state) => state.id === address.state);

    if (stateEnum) {
      return stateEnum.name+',';
    } else {
      return address.state+',';
    }
  }

  return (
    <>
    <AddressFormModal
        path={type === "shipping" ? ApiResources.updateOrderShippingAddress(record.id, false) : ApiResources.updateOrderBillingAddress(record.id, false)}
        title={`${type === "shipping" ? "Shipping" : "Billing"} Address`}
        open={showAddressEdit}
        setOpen={setShowAddressEdit}
        address={address}
    />    
    <Card
      sx={cardStyle}
      {...rest}
    >
      <CardHeader
        sx={{ padding: "12px" }}
        avatar={
          <Avatar
            sx={{
              bgcolor: theme.palette.grey["200"],
            }}
          >
            <BusinessIcon
              color="primary"
              sx={{fontSize:"16px"}}
            />
          </Avatar>
        }
        title={`${address.first_name} ${address.last_name}`}
        titleTypographyProps={{ fontSize: "14px", fontWeight: "500" } }
        subheader={address.company}
      />

      <Box display="flex" alignItems="center" sx={sectionStyle}>
        <HomeIcon sx={iconStyle} />
        <Box>
          <Typography
            sx={textStyle}
          >{`${address.street_address}, ${address.city} ${address.zip}`}</Typography>
          <Typography
            sx={textStyle}
          >{`${getState(address)} ${address.country}`}</Typography>
        </Box>
      </Box>

      <Box display="flex" alignItems="center" sx={sectionStyle}>
        <LocalPhoneIcon sx={iconStyle} />
        <Box>
          <Typography sx={textStyle}>{phoneNumberFormat(address.phone)}</Typography>
          <Typography sx={textStyle}>{phoneNumberFormat(address.mobile)}</Typography>
        </Box>
      </Box>

      <Box display="flex" sx={sectionStyle}>
        <AlternateEmailIcon sx={iconStyle} />
        <Typography sx={textStyle}>{address.email}</Typography>
      </Box>

      {address.note &&
      <Box display="block" sx={{...sectionStyle, marginTop: "20px"}}>
        <Typography sx={{...textStyle, fontWeight: "500"}}>Note: <Typography component="span" sx={textStyle}>{address.note}</Typography></Typography>
      </Box> 
      }

      <Box display="flex" justifyContent="end">
        <Button
          variant="outlined"
          size="small"
          onClick={() => setShowAddressEdit(true)}
        >
          Edit
        </Button>
      </Box>
    </Card>
    </>
  );
};
